import type { I18nPrefix } from '@sparklayer-io/dashboard/i18n/prefix';
import type { RouteTitle } from '@sparklayer-io/dashboard/i18n/route-title';
import { t } from 'i18next';

const I18N_DOCUMENT_TITLE = 'features:app.document_title' satisfies I18nPrefix;

/** `document.title` for the matched leaf route, or the dashboard name alone when it has no title. */
export function documentTitle(title: RouteTitle | undefined): string {
  if (!title) return t(`${I18N_DOCUMENT_TITLE}.default`);
  return t(`${I18N_DOCUMENT_TITLE}.page`, { title: t(`${I18N_DOCUMENT_TITLE}.pages.${title}`) });
}
